import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import './styles/index.scss';
import Sentry from './services/sentry/sentry';
import App from './App';
import AppProvider from './context/AppProvider';
import AuthProvider from './context/AuthProvider';
import ErrorProvider from './context/ErrorProvider';
import ToastProvider from './components/Toast/ToastProvider';
import reportWebVitals from './reportWebVitals';
import { reloadOnChunkError } from './utilities/helpers/errors';
import AppError from './components/AppError/AppError';
import AppLoader from './components/AppLoader/AppLoader';

const queryClient = new QueryClient();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary
      fallback={({ error }) => {
        if (/Loading (chunk|CSS chunk) \d+ failed/.test(error.message)) {
          reloadOnChunkError(error);
        }
        return <AppError />;
      }}>
      <AppProvider>
        <QueryClientProvider client={queryClient}>
          <BrowserRouter>
            <ErrorProvider>
              <AppLoader>
                <AuthProvider>
                  <ToastProvider>
                    <App />
                  </ToastProvider>
                </AuthProvider>
              </AppLoader>
            </ErrorProvider>
          </BrowserRouter>
        </QueryClientProvider>
      </AppProvider>
    </Sentry.ErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
